export default __webpack_public_path__ + "static/media/glow.def60647.png";